import { bindRequestLogic } from './utils'
import PersPackageTypes from '../actionTypes/persPackage'
import { persPackageAPI } from '../api'

const getPersPackages = bindRequestLogic({
  clientFunc: persPackageAPI.getPersPackages,
  type: PersPackageTypes.GET_PERS_PACKAGES_REQUEST,
  successType: PersPackageTypes.GET_PERS_PACKAGES_SUCCESS,
  failType: PersPackageTypes.GET_PERS_PACKAGES_FAILED,
  isQueryParam: true
})

const getPersPackageById = bindRequestLogic({
  clientFunc: persPackageAPI.getPersPackageById,
  type: PersPackageTypes.GET_PERS_PACKAGE_BY_ID_REQUEST,
  successType: PersPackageTypes.GET_PERS_PACKAGE_BY_ID_SUCCESS,
  failType: PersPackageTypes.GET_PERS_PACKAGE_BY_ID_FAILED
})

export default [getPersPackages, getPersPackageById]
